export default "/images/759d82d9683df99f172d3d86c139f77f.avif";